import styled from 'styled-components';

interface Props {
	fullHeight?: boolean;
}
export const Container = styled.div<Props>`
	padding-top: 4rem;
	height: ${props => (props.fullHeight ? '100vh' : '100%')};
`;
